import React from 'react';
import I18n from '../../../i18n/I18n';
import Button from '../button/Button';
import LocaleLink from '../LocaleLink';
import styles from './WidgetTitle.scss';

type Props = {
    title: string,
    btntext: string,
    enableBtn: boolean,
}

const Title = (props: Props) => {
  const title = props.title || '';
  const btnText = props.btnText || '';
  return (
    <div className={styles.titleWrapper}>
      <h4 className={styles.title}>
        {title}
      </h4>
      <div className={styles.btnCtr}>
        {props.enableBtn
          ? <LocaleLink to={props.btnLink} className={styles.flexer}>
              <Button variant="transparent">
                {btnText}
              </Button>
            </LocaleLink>
          : ''}
      </div>
    </div>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/common/widgetTitle/WidgetTitle.js